export default __webpack_public_path__ + "static/11_31-d3c7ebbf0a312894882968bd52a047c6.png";